import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {
    userSearchResultSavedSearchesDataSelector,
    userSearchResultSavedSearchesResultSelector,
} from '../../slices/user-search-result-saved-searches.slice';

type Props = {
    userId: number,
};

export const SavedSearchesCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultSavedSearchesDataSelector);
    const result = useSelector(userSearchResultSavedSearchesResultSelector);

    const savedSearch = useMemo(
        () => result?.data[userId],
        [result, userId],
    );

    if (isLoading || loadingError || !savedSearch) {
        return null;
    }

    return (
        <span>
            {[
                savedSearch.savedSearchesCount,
                savedSearch.alertsCount
                    ? `(${savedSearch.alertsCount})`
                    : null,
            ].filter(Boolean).join(' ')}
        </span>
    );
};
